export interface Address {
  nameOrNumber?: string
  line1?: string
  city?: string
  postcode?: string
}

export const getAddressFirstLine = (address: Address): string =>
  `${address.nameOrNumber?.toLowerCase() ?? ''} ${address.line1?.toLowerCase() ?? ''}`

export const getAddressSecondLine = (address: Address): string =>
  `${address.city?.toLowerCase()} ${address.postcode}`
